import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import BrandsShowcase from "@/components/site/BrandsShowcase";
import Sustainability from "@/components/site/Sustainability";
import GroupPanel from "@/components/site/GroupPanel";
import TradeShows from "@/components/site/TradeShows";
import B2BInquiry from "@/components/site/B2BInquiry";
import PortfolioPromo from "@/components/site/PortfolioPromo";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import BrandPage from "@/pages/BrandPage";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import DistributorLogin from "@/pages/distributor/DistributorLogin";
import DistributorRegister from "@/pages/distributor/DistributorRegister";
import DistributorPortal from "@/pages/distributor/DistributorPortal";
import { Navigate } from "react-router-dom";
import { Toaster } from "sonner";

// Handle URLs like `/#brands` — scroll to the section when landing on home.
function HashScroller() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (pathname !== "/") return;
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [hash, pathname]);
  return null;
}

const Home = () => (
  <div className="App">
    <Header />
    <main>
      <Hero />
      <About />
      <BrandsShowcase />
      <Sustainability />
      <TradeShows />
      <PortfolioPromo />
      <B2BInquiry />
      <GroupPanel />
      <Contact />
    </main>
    <Footer />
  </div>
);

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#F7F5EE] text-sm text-black/50">Loading…</div>;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/distributors/login"} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <HashScroller />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/brands/:slug" element={<BrandPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="/distributors/login" element={<DistributorLogin />} />
            <Route path="/distributors/register" element={<DistributorRegister />} />
            <Route path="/distributors/portal" element={<Protected role="distributor"><DistributorPortal /></Protected>} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
